import { __decorate, __metadata, __param } from 'tslib';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let IntroService = class IntroService {
    constructor(storage) {
        this.storage = storage;
    }
    cleanStorage() {
        this.storage.clear().then(x => {
            // console.log(x);
        });
    }
};
IntroService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage])
], IntroService);

var UiBsIntroModule_1;
let UiBsIntroModule = UiBsIntroModule_1 = class UiBsIntroModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsIntroModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsIntroModule = UiBsIntroModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            })
        ],
        providers: [
            IntroService
        ],
        exports: []
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsIntroModule])
], UiBsIntroModule);

export { IntroService, UiBsIntroModule };
//# sourceMappingURL=wlp-ui-bs-intro.js.map
